const md5 = require('browser-md5');

export const getRouteId = ({ location }) => {
  const url = `${location.pathname}`;
  const hash = md5(url);
  return hash;
};
